module.exports = __webpack_public_path__ + "assets/img/included.2cb9e486.png";